/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
**************************************************************************/
/* eslint-disable no-underscore-dangle */

import { DoublyLinkedList, DoublyLinkedNode } from "../utils/DoublyLinkedList";

/**
 * Stores resource requests for FCFS processing.
 */
export default class AwaitQueue {
    constructor() {
        this._awaitQueue = new DoublyLinkedList();
    }

    /**
     * Adds request to queue for FCFS processing.
     */
    addResourceRequest = () => new Promise(resolve => {
        this._awaitQueue.append(new DoublyLinkedNode(() => {
            resolve();
        }));
    })

    /**
     * @returns true if a request is pending execution.
     */
    hasPendingRequest = () => !this._awaitQueue.isEmpty();

    /**
     * Executes worker request if one is pending.
     */
    executeRequest = () => {
        if (this.hasPendingRequest()) {
            const requestCompletionCallback = this._awaitQueue.front().value;
            requestCompletionCallback();
        }
    }
}
